import { render } from "./ConstructionTab.vue?vue&type=template&id=dfc87ece"
import script from "./ConstructionTab.vue?vue&type=script&lang=js"
export * from "./ConstructionTab.vue?vue&type=script&lang=js"

import "./ConstructionTab.vue?vue&type=style&index=0&id=dfc87ece&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__